import { useEffect, useRef, useState } from "react";
import BetUserImg from '../assets/images/betUserimg.png'
import BetUserImg2 from '../assets/images/betUserimg2.png'
import { callChart, currentMultiplier, setCrashTime, idlePlane, planeCrash, currentStatus, setCrashed } from '../assets/js/plane.js'
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../app/store";
import AuthService from "../services/auth.service";
import { useNavigate } from "react-router-dom";
import echo from '../services/echo';
import Loader from "../components/loader";
import AviatorBoard from "../components/aviator-board";
import { useEchoWhenConnected } from '../hooks/useEchoWhenConnected';

const getClientUnixTime = (): number => {
    return (performance.timeOrigin + performance.now()) / 1000; // seconds
};

interface BetData {
    image: string;
    user_name: string,
    bet_amount: number,
    cashed_out_at: number,
    id: number,
    final_payout: any
}

function Aviator() {
    const walletAmount = useSelector((state: RootState) => state.wallet.wallet);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [waitMessage, setWaitMessage] = useState("");
    const [showAll, setShowAll] = useState(false);
    const [progress, setProgress] = useState<number>(0);
    const [isGameActive, setIsGameActive] = useState(false);
    const [isBetPlaced, setIsBetPlaced] = useState(false);
    const [isCrashed, setIsCrashed] = useState<any>();
    const [isBetOpen, setIsBetOpen] = useState<any>();

    const [betHistory, setBetHistory] = useState<BetData[]>([]);
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalWin, setTotalWin] = useState(0);
    const [roundsHistory, setRoundsHistory] = useState<any>([]);
    const [gameLoading, setGameLoading] = useState(true);
    const [maxRange, setMaxRange] = useState<number>(0);
    const [totalMultiplier, setTotalMultiplier] = useState<number | any>(0);
    const [betAmount, setBetAmount] = useState<any | Number>('');
    const [wallet, setWallet] = useState<any | Number>(walletAmount);
    const dispatch = useDispatch<AppDispatch>();
    const [isAutoCall, setIsAutoCall] = useState<boolean>(false);
    const [betType, setBetType] = useState<any>('manual');
    const [gameData, setGameData] = useState<any>();
    const [isCashout, setIsCashout] = useState(false);

    // const [gameStartTime, setGameStartTime] = useState<any>(0);
    const [isPageloading, setIsPageLoading] = useState(false);
    const navigate = useNavigate();
    // Example values — 20 identical buttons for testing
    const values = Array(12).fill(4.44);

    // Decide which values to show
    const visibleValues = showAll ? values : values.slice(0, 5);
    const gameStartTime = useRef<(number | any)>();
    const currMulti = useRef<(number | any)>();
    const [multiplier, setMultiplier] = useState<any>(currMulti.current);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);


    const bets: BetData[] = [
        { user_name: 'm***0', bet_amount: 6000, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'a***2', bet_amount: 4500, image: BetUserImg2, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'j***8', bet_amount: 3200, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'm***0', bet_amount: 6000, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'a***2', bet_amount: 4500, image: BetUserImg2, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'j***8', bet_amount: 3200, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'm***0', bet_amount: 6000, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'a***2', bet_amount: 4500, image: BetUserImg2, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'j***8', bet_amount: 3200, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'm***0', bet_amount: 6000, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'a***2', bet_amount: 4500, image: BetUserImg2, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'j***8', bet_amount: 3200, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'm***0', bet_amount: 6000, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'a***2', bet_amount: 4500, image: BetUserImg2, id: 5, cashed_out_at: 1.5, final_payout: 100 },
        { user_name: 'j***8', bet_amount: 3200, image: BetUserImg, id: 5, cashed_out_at: 1.5, final_payout: 100 },
    ];



    useEchoWhenConnected(() => {
        // const status = echo.connector.pusher.connection.state; 
        // console.log('Current status:', status);

        // if(status==='connected'){
        setIsPageLoading(true);
        AuthService.loadAviator()
            .then(
                (response) => {
                    // console.log(response.data?.current_multiplier);
                    if (response.status === 200) {
                        // currMulti.current = ""
                        // setTimeout(() => {                            
                        setIsBetOpen(response.data?.is_open);
                        setIsCrashed(response.data?.is_crashed);
                        setBetHistory(response.data?.history);
                        setTotalUsers(response.data?.history?.length)
                        setRoundsHistory(response.data?.round_history)
                        if (Number(response.data?.is_open) === 1) {
                            gameStartTime.current = response.data?.started_at;
                            currMulti.current = response.data?.current_multiplier;
                        }

                        // }, 100);

                        // getMultiplier(response.data?.started_at);
                    }
                }
            ).catch((error) => {
                //console.log(error?.status, error?.response?.data?.status)
                const message = error?.response?.data?.error_description;
                setMessage(message);
                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                }
            }).finally(() => {
                setIsPageLoading(false);
            });
        // };
        // eslint-disable-next-line
    });


    useEffect(() => {

        //setIsPageLoading(true);
        const channel = echo.channel('crash-channel');
        const channelEnd = echo.channel('crash-end');
        channel.listen(".crash.update", (data: any) => {
            console.log('Received data:', data);
            setIsBetOpen(data?.game?.is_open);
            setIsCrashed(data?.game?.is_crashed);
            currMulti.current = ""
            if (Number(data?.game?.is_open) === 1) {
                gameStartTime.current = data?.game?.start_time;
            }

        });

        channel.listen(".bet.history", (data: any) => {
            console.log('bet history data:', data?.history);
            setBetHistory(prevBets => {
                const existingIndex = prevBets.findIndex(bet => bet.id === data?.history.id);
                if (data?.history?.is_cancel) {
                    const exists = prevBets.some(bet => bet.id === data?.history.id);
                    if (exists) {
                        setTotalUsers(prev => prev - 1);
                        return prevBets.filter(bet => bet.id !== data?.history.id);
                    }
                }

                if (existingIndex !== -1) {
                    const updatedBets = [...prevBets];
                    updatedBets[existingIndex] = data?.history;
                    setTotalUsers(prev => prev - 1);
                    setTotalWin((prev: number) => prev + Number(data?.history.final_payout))
                    return updatedBets;
                }
                setTotalUsers(prev => prev + 1);
                return [data?.history, ...prevBets];
            });
            // setBetHistory(prevBets => [data?.history, ...prevBets]);
        });

        channelEnd.listen(".crash.ended", (data: any) => {
            console.log('End data:', data);
            setIsGameActive(false);
            setIsBetOpen(data?.game?.is_open);
            setIsCrashed(data?.game?.is_crashed);
            setTotalMultiplier(data?.game?.multiplier);
            setGameData(data);

        });

        return () => {
            echo.leave('crash-channel');
            echo.leave('crash-end');
        };
    }, []);


    useEffect(() => {

        if (gameData) {
            setTotalMultiplier(gameData?.game?.multiplier);
            setRoundsHistory((prevItems: any) => {
                const updated = [gameData?.game?.multiplier, ...prevItems];
                return updated.slice(0, 10);
            });

        }
    }, [gameData]);

    function getMultiplier(gameStartTime: number) {
        // const currentTime = Date.now(); // in ms
        // // const elapsed = currentTime - gameStartTime;
        // // const steps = Math.floor(elapsed / 100);
        // // let multiplier = 1 + steps * 0.01;
        // let multiplier = 1 + Math.floor((currentTime - gameStartTime) / 100) * 0.01;
        const currentTime = getClientUnixTime();//Date.now();
        //const readable = new Date(currentTime).toLocaleString();
        const offset = currentTime - gameStartTime;
        // console.log(currentTime, gameStartTime);
        const startTime = offset > 0 ? offset : 0;
        const start = performance.now();
        let curr = parseFloat(currMulti.current)
        // currMulti.current = "";
        if (isCrashed === undefined || isCrashed === null || isCrashed === 0) {
            intervalRef.current = setInterval(() => {
                const now = performance.now();
                const elapsed = (now - start) / 1000; // in seconds
                const current = startTime + elapsed;

                currMulti.current = ((curr ? curr : 1) + parseFloat(current.toFixed(2)) / 10);
                setMultiplier(currMulti.current);

                //console.log(gameStartTime, (1 + parseFloat(current.toFixed(2)) / 10).toFixed(2), isCrashed, isBetOpen);

            }, 10);
        }

        // if (isCrashed === 1) {
        //     console.log("🔥 Crash detected");
        //     // setTotalMultiplier(parseFloat(currMulti.current).toFixed(2))
        //     currMulti.current = undefined;
        //     setMultiplier(currMulti.current);
        //     if (intervalRef.current) {
        //         clearInterval(intervalRef.current);
        //         intervalRef.current = null;
        //     }
        //     return;
        // }

        //return Math.round(multiplier * 100) / 100;
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };

    }


    useEffect(() => {

        if ((isCrashed === null || isCrashed === 0) && (isBetOpen === null || isBetOpen === 0)) {
            console.log("bet open & progress bar");
            setBetHistory([]);
            setGameLoading(true);
            setIsGameActive(true);
            idlePlane();
            setProgress(0);
            progressBar();
            setCrashed(false);
            setMessage("");
            setTotalWin(0);
            currMulti.current = undefined;
            setMultiplier(undefined);
        }

        if ((isCrashed === null || isCrashed === 0) && isBetOpen === 1) {
            console.log("bet close & flew");
            setIsGameActive(true);
            setIsCrashed(false);
            setGameLoading(false);
            // setProgress(0);
            callChart();
            // setCrashed(false);
            getMultiplier(gameStartTime.current);

        }

        if (isCrashed === 1 && isBetOpen === 1) {
            console.log("crashed 2");
            planeCrash();
            setCrashed(true);
            setIsGameActive(false);
            setMessage("");
            //setTotalMultiplier(parseFloat(currMulti.current).toFixed(2))
            currMulti.current = undefined;
            setMultiplier(undefined);
            setTotalUsers(0);
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            // console.log(gameData?.game?.multiplier)
            //setCrashTime(gameData?.game?.multiplier)
        }

    }, [isBetOpen, isCrashed, isGameActive]);


    const toggleButtonHist = () => {
        setShowAll(prev => !prev);
    };

    useEffect(() => {
        idlePlane();
        progressBar();
    }, []);

    useEffect(() => {
        setWallet(walletAmount);
    }, [walletAmount]);


    function progressBar() {
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval); 
                    return 100;
                }
                return prev + 1;
            });
        }, 400); // speed of progress

        return () => clearInterval(interval); // cleanup
    }


    return (
        <>
            {isPageloading && <Loader />}
            <div>
                <div className="container webMine">
                    <div className="row aviagameBagk px-2 bg-dark-Bet">
                        <div className="col-12 position-relative planeped">
                            <div className="aviatorMain">
                                <div className="betHistory">
                                    <div className="betHistorybtn">
                                        {roundsHistory.length > 0 && roundsHistory.map((value: any, index: number) => (
                                            <button key={index} className={index > 4 ? 'd-none d-sm-block' : ''}>
                                                {Number(value)} <span>x</span>
                                            </button>
                                        ))}
                                    </div>

                                    {/* {values.length > 10 && (
                                        <button onClick={toggleButtonHist} className="toggleButtonHist">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="18"
                                                height="19"
                                                viewBox="0 0 18 19"
                                                fill="none"
                                            >
                                                <path
                                                    d="M9 18.25C13.8324 18.25 17.75 14.3324 17.75 9.49998C17.75 4.66749 13.8324 0.749985 9 0.749985C4.16751 0.749985 0.25 4.66749 0.25 9.49998C0.25 14.3324 4.16751 18.25 9 18.25ZM13.775 7.27496L8.125 12.9249L4.44378 9.2437L5.68122 8.00627L8.125 10.4501L12.5375 6.03751L13.775 7.27496Z"
                                                    fill="#788BCF"
                                                />
                                            </svg>
                                        </button>
                                    )} */}
                                </div>

                                {isGameActive && gameLoading &&
                                    <div className="planeLoder">
                                        <div className="progress" style={{ position: 'relative' }}>
                                            <div
                                                className="progress-bar"
                                                role="progressbar"
                                                style={{ width: `${progress}%` }}
                                                aria-valuenow={progress}
                                                aria-valuemin={0}
                                                aria-valuemax={100}
                                            >
                                                {progress}%
                                            </div>
                                        </div>
                                    </div>
                                }

                                {!isGameActive && !isPageloading &&
                                    <div className="winScor overGameScor">
                                        <h4>{message}</h4>
                                    </div>
                                }

                                {/* Add class on Game Over  -----> overGameScor ---- */}
                                {isCrashed === Number(1) && isBetOpen === Number(1) &&
                                    <div className="winScor overGameScor">
                                        <h4>Flew Away!</h4>
                                        <h1 className="planeUpscor">{totalMultiplier}x</h1>
                                    </div>
                                }

                                {isCrashed == "" && isBetOpen === Number(1) &&
                                    <div className="winScor currentMultiplier" style={{ zIndex: "99" }}>
                                        <h1 className="planeUpscor" id="currentMultiplier"> {`${isNaN(multiplier) ? "1.00" : Number(multiplier).toFixed(2)}x`}</h1>
                                    </div>
                                }


                                <div className="aroplane74win">
                                    <canvas id="myCanvasPalne" width="500" height="500" className="myCanvasPalne"></canvas>
                                </div>
                            </div>
                        </div>
                        <AviatorBoard id={1} isGameActive={isGameActive} isBetOpen={isBetOpen} isCrashed={isCrashed} multiplier={multiplier} totalUsers={betHistory?.length} />
                        <AviatorBoard id={2} isGameActive={isGameActive} isBetOpen={isBetOpen} isCrashed={isCrashed} multiplier={multiplier} totalUsers={betHistory?.length} />

                    </div>
                    <div className='row aviAutobet'>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="col-12 betSelection mb-my">
                                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="pills-AllBets-tab" data-bs-toggle="pill" data-bs-target="#pills-AllBets" type="button" role="tab" aria-controls="pills-AllBets" aria-selected="true">All Bets</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="pills-MyBets-tab" data-bs-toggle="pill" data-bs-target="#pills-MyBets" type="button" role="tab" aria-controls="pills-MyBets" aria-selected="false">My Bets</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="pills-Leaderboard-tab" data-bs-toggle="pill" data-bs-target="#pills-Leaderboard" type="button" role="tab" aria-controls="pills-Leaderboard" aria-selected="false">Leaderboard</button>
                                    </li>
                                </ul>
                            </div>
                            <div className="tab-pane fade show active" id="pills-AllBets" role="tabpanel" aria-labelledby="pills-AllBets-tab">
                                <div className="d-flex justify-content-between align-items-center
">
                                    <h1 className="aviatorBetListTitl">{totalUsers}/{betHistory?.length} Bets</h1>
                                    <h1 className="aviatorBetListTitl">Total win (INR) : {Number(totalWin).toFixed(2)}</h1>
                                </div>
                                <ul className="aviatorBetList">
                                    <li className="aviatorBetListHedings">
                                        <div>Player</div>
                                        <div>Bet INR</div>
                                        <div>X</div>
                                        <div>Win INR</div>
                                    </li>
                                    {betHistory.length > 0 && betHistory.map((bet, index) => (
                                        <li key={index} className={`aviatorBetListData ${bet?.cashed_out_at && 'cashoutBet'}`}>
                                            <div className="d-flex justify-content-start align-items-center">
                                                <img src={bet.image ? bet.image : BetUserImg} alt="user" className="img-fluid" />
                                                <p className="betusNam">{bet.user_name}</p>
                                            </div>
                                            <div className="BetInr">
                                                <p>{bet?.bet_amount?.toLocaleString()}</p>
                                            </div>
                                            {bet?.cashed_out_at &&
                                                <div className="BetInr">
                                                    <p>{bet.cashed_out_at}</p>
                                                </div>
                                            }
                                            {bet?.cashed_out_at &&
                                                <div className="BetInr">
                                                    <p>{bet?.final_payout?.toLocaleString()}</p>
                                                </div>
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="tab-pane fade" id="pills-MyBets" role="tabpanel" aria-labelledby="pills-MyBets-tab">
                                <h1 className="aviatorBetListTitl">My Bets 2933</h1>
                                <ul className="aviatorBetList">
                                    <li className="aviatorBetListHedings">
                                        <div>User</div>
                                        <div>Bet INR X</div>
                                        <div>Cash out INR</div>
                                    </li>
                                    {bets.map((bet, index) => (
                                        <li key={index} className="aviatorBetListData cashoutBet">
                                            <div className="d-flex justify-content-start align-items-center">
                                                <img src={bet.image} alt="user" className="img-fluid" />
                                                <p className="betusNam">{bet.user_name}</p>
                                            </div>
                                            <div className="BetInr">
                                                <p>{bet?.bet_amount?.toLocaleString()}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="tab-pane fade" id="pills-Leaderboard" role="tabpanel" aria-labelledby="pills-Leaderboard-tab">
                                <h1 className="aviatorBetListTitl">Leaderboard 2933</h1>
                                <ul className="aviatorBetList">
                                    <li className="aviatorBetListHedings">
                                        <div>User</div>
                                        <div>Bet INR X</div>
                                        <div>Cash out INR</div>
                                    </li>
                                    {bets.map((bet, index) => (
                                        <li key={index} className="aviatorBetListData">
                                            <div className="d-flex justify-content-start align-items-center">
                                                <img src={bet.image} alt="user" className="img-fluid" />
                                                <p className="betusNam">{bet.user_name}</p>
                                            </div>
                                            <div className="BetInr">
                                                <p>{bet?.bet_amount?.toLocaleString()}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Aviator;